<template>
  <v-subheader class="grey lighten-2">
    <v-row dense class="text--primary body-1 font-weight-medium">
      <v-col cols="12" :sm="disableActions ? 4 : 3" class="d-flex align-center">
        {{ carrinho.respostaCotacao.cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
        <px-finalidade-compra-value
          :finalidade-compra="carrinho.respostaCotacao.cotacao.finalidadeCompra"/>
      </v-col>
      <v-col cols="12" sm="1" class="d-flex align-center">
        <px-forma-pagamento
          :forma-pagamento="carrinho.respostaCotacao.formaPagamento"
          :prazo-pagamento="carrinho.respostaCotacao.prazoPagamento"/>
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
            <span v-if="carrinho.frete">
              {{ carrinho.respostaCotacao.frete.tipoFrete }}
              ({{ carrinho.frete | currency }})
            </span>
        <span v-else>
              {{ carrinho.respostaCotacao.frete.tipoFrete }}
            </span>
      </v-col>
      <v-col cols="12" sm="3" class="d-flex align-center">
        Total:
        <div class="pl-2">
          {{ totalCarrinho.totalConvertido
          | currency('R$', casaDecimal) }}
          <div class="caption" v-if="isMoedaEstrangeira">
            {{ totalCarrinho.total |
          currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
          </div>
        </div>
        <px-moeda-chip v-if="isMoedaEstrangeira" class="ml-2 mb-5" :moeda="moeda"/>
      </v-col>
      <v-col cols="12" sm="1"
             v-if="!disableActions && hasRoleComprador"
             class="d-flex align-center justify-end">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn icon
                     small
                     @click.stop="removerCarrinho(carrinho.id)"
                     title="Remover todos os produtos do carrinho">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </span>
          </template>
          <span>Remover todos os produtos do carrinho</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-subheader>
</template>
<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';
import { totalCarrinho } from './calculo-carrinho.service';

export default {
  mixins: [moedaMixin],
  name: 'ListagemCarrinhoRespostas',
  props: {
    carrinho: {
      type: Object,
      required: true,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    removerCarrinho: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    moeda() {
      return this.carrinho.respostaCotacao.moeda;
    },
    casaDecimal() {
      const produtos = this.carrinho.produtos
        .map(produto => produto.respostaCotacaoProduto.cotacaoProduto.produto);
      return CasaDecimalUtils.getCasaDecimal(produtos);
    },
    totalCarrinho() {
      return totalCarrinho(this.carrinho);
    },
  },
};
</script>
